<template>
  <v-tooltip v-if="kind" bottom max-width="320">
    <template #activator="{ on, attrs }">
      <v-chip x-small outlined color="grey" class="badge-origin" v-bind="attrs" v-on="on">{{ $t(`rfid.${kind}${kind === 'third-party' ? '-chip' : ''}`) }}</v-chip>
    </template>
    <span>{{ $t(`rfid.${kind}-hint`) }}</span>
  </v-tooltip>
</template>

<script>
/**
 * D'où vient un badge, dit discrètement quand ce n'est pas un badge du réseau connu — pour information, ce n'est pas une
 * alerte, le badge fonctionne :
 * - « Tiers » : fourni par un tiers (parking, carte d'accès…), sans itinérance (le drapeau `private` du token) ;
 * - « Origine inconnue » : un badge du réseau que l'inventaire des badges ne connaît pas (entré avant, fichier manquant).
 */
export default {
  name: 'BadgeOriginChip',
  props: {
    token: { type: Object, required: true },
  },
  computed: {
    kind() {
      if (this.token.private) return 'third-party'
      return this.token.inInventory === false ? 'not-in-inventory' : null
    },
  },
}
</script>

<style scoped>
.badge-origin {
  vertical-align: middle;
}
</style>
